import * as React from 'react'
import StandardInput from '../../common/components/standard-input'
import SelectionInput from '../../common/components/selection-input'
import YesNoInput from '../../common/components/yes-no-input'
import Validation from '../../common/modules/validation/rules'
import Alert from '../../common/components/alert'
import { mapValues } from 'lodash'
import * as moment from 'moment'
import QuoteNumber from '../../common/components/quote-number'
import StepTitle from '../../common/components/step-title'
import SubHeader from '../../common/components/sub-header'
import StepBlock from '../../common/components/step-block'
import Button from '../../common/components/button'
import InputField from '../../common/components/input-field'
import yesNoOptions from '../../common/options/yes-no-options'
import { toCurrency } from '../../common/util'
import { withValidation } from '../../common/modules/validation'
import { withForm } from '../../common/modules/form'
import { withStatus } from '../../common/modules/status'
import { withSubmission } from '../../common/modules/submission'
import { withNavigation } from '../../common/modules/navigation'
import { withRouteBlocker } from '../../common/modules/route-blocker'
import { withFields } from '../../common/modules/fields'
import { withProductData } from '../../common/modules/product-data'
import { withState } from '../../common/modules/state'
import { withScrollToTop } from '../../common/modules/scroll-to-top'
import { get } from 'lodash'


export const formConfig = state => {
    const productData = state.productData;
    const fields = state.fields;

    return {
        predicates: {
            paintBenefit:           get(fields, "ownersCorporationAddress.state") == "ACT" || get(fields, "ownersCorporationAddress.state") == "NSW",
            yearRewired:            fields.buildingSumInsured > 1000000 && moment().year() - fields.yearBuilt > 57,
            yearReplumbed:          fields.buildingSumInsured > 1000000 && moment().year() - fields.yearBuilt > 57,
            yearRefurbished:        fields.buildingSumInsured > 1000000 && moment().year() - fields.yearBuilt > 57,
            heritageListed:         fields.buildingSumInsured > 1000000 && moment().year() - fields.yearBuilt > 80,
            equipmentInBasements:   fields.numberOfBasements > 0
        },
        rules: {
            paintBenefit:[
                Validation.enforce.required("Please tell us if you require cover"),
            ],
            yearBuilt:[
                Validation.enforce.required("Please enter a valid year"),
                Validation.enforce.year("Please enter a valid year"),
                Validation.enforce.rangeInclusive(1800, moment().year(), "Must be between 1800 and " + moment().year())
            ],
            yearRewired:[
                Validation.enforce.required("Please enter a valid year"),
                Validation.enforce.rangeInclusive(fields.yearBuilt, moment().year(), "Must be between "+ fields.yearBuilt +" and " + moment().year())
            ],
            yearReplumbed:[
                Validation.enforce.required("Please enter a valid year"),
                Validation.enforce.rangeInclusive(fields.yearBuilt, moment().year(), "Must be between "+ fields.yearBuilt +" and " + moment().year())
            ],
            yearRefurbished:[
                Validation.enforce.required("Please enter a valid year"),
                Validation.enforce.rangeInclusive(fields.yearBuilt, moment().year(), "Must be between "+ fields.yearBuilt +" and " + moment().year())
            ],
            heritageListed:[
                Validation.enforce.required("Please answer the question"),
            ],
            numberOfLots:[
                Validation.enforce.required("Please enter the number of lots"),
                Validation.enforce.greaterThanEqual(2, "Number of lots must be at least 2"),
                Validation.enforce.number("Must be a whole number")
            ],
            numberOfFloors:[
                Validation.enforce.required("Please enter the number of floors"),
                Validation.enforce.rangeInclusive(1, 50, "Must be between 1 and 50"),
                Validation.enforce.number("Must be a whole number")
            ],
            numberOfBasements:[
                Validation.enforce.required("Please enter the number of basements"),
                Validation.enforce.rangeInclusive(0, 20, "Must be between 0 and 20"),
                Validation.enforce.number("Must be a whole number")
            ],
            equipmentInBasements:[
                Validation.enforce.required("Please specify if there is plant or equipment in the basement(s)"),
            ],
            commerciallyUsed:[
                Validation.enforce.required("Please answer the question"),
            ],
            knownDefects:[
                Validation.enforce.required("Please answer the question"),
            ],
            wallConstruction:[
                Validation.enforce.required("Please select a value"),
            ],
            roofConstruction:[
                Validation.enforce.required("Please select a value"),
            ],
            floorConstruction:[
                Validation.enforce.required("Please select a value"),
            ],
            epsPercent:[
                Validation.enforce.required("Please enter a value"),
                Validation.enforce.rangeInclusive(0, 100, "Must be between 0 and 100"),
                Validation.enforce.number("Must be a whole number")
            ],
            aluminiumCompositePanels:[
                Validation.enforce.required("Please answer the question"),
            ]
        },
        inferred: {},
        transformOut: data => data,
        options: {
            heritageListed: yesNoOptions,
            paintBenefit: yesNoOptions,
            wallConstruction: productData.productOptions.WALL_CONSTRUCTION,
            roofConstruction: productData.productOptions.ROOF_CONSTRUCTION,
            floorConstruction: productData.productOptions.FLOOR_CONSTRUCTION,
            equipmentInBasements: yesNoOptions,
            commerciallyUsed: yesNoOptions,
            knownDefects: yesNoOptions,
            aluminiumCompositePanels: yesNoOptions
        },
    }
}



@withSubmission
@withNavigation
@withProductData
@withValidation
@withFields
@withRouteBlocker
@withScrollToTop
@withStatus
@withForm(formConfig)
export default class extends React.Component<any, any> {


    render() {
        const actions = this.props.actions;
        const fields = this.props.fields;
        
        return (
            <div className="row">
                <StepTitle>Tell Us About Your Building Details</StepTitle>
                <QuoteNumber />

                <InputField    field="buildingName"                type="String"       inline={ true }           label="Building Name"                                                              placeholder="Optional" />
                <InputField    field="yearBuilt"                   type="Year"         inline={ true }           label="When was the building originally built?"                                              />
                <InputField    field="yearRewired"                 type="Year"         inline={ true }           label="When was the building last rewired?"                                                  />
                <InputField    field="yearReplumbed"               type="Year"         inline={ true }           label="When was the building last re-plumbed?"                                               />
                <InputField    field="yearRefurbished"             tyes="Year"         inline={ true }           label="When was the building last refurbished?"                                              />
                <InputField    field="heritageListed"              type="Boolean"                                label="Is your building heritage listed?"                                                    />
                <InputField    field="numberOfLots"                type="Number"       inline={ true }           label="How many lots are there in your building?"                                            />
                <InputField    field="numberOfFloors"              type="Number"       inline={ true }           label="How many floors are there in your building?"                                help="This includes the ground floor, but excludes any basements or floors below ground."/>
                <InputField    field="numberOfBasements"           type="Number"       inline={ true }           label="How many basements or floors below ground are there in your building?"                />
                <InputField    field="paintBenefit"                type="String"       inline={ true }           label="Do you want to cover Lot/Unit Wall Coverings?"                                        />
                <InputField    field="equipmentInBasements"        type="Boolean"                                label="Is there any equipment or plant in the basement(s)?"                                  />
                <InputField    field="commerciallyUsed"            type="Boolean"                                label="Is more than 20% of your building (by floor area) used for commercial purposes?"      />
                <InputField    field="knownDefects"                type="Boolean"      inline={ true }           label="Are there any known defects of the building?"                                         />
                <InputField    field="wallConstruction"            type="String"       inline={ true }           label="What is the construction material of the building's external walls?"                  />
                <InputField    field="roofConstruction"            type="String"       inline={ true }           label="What is the construction material of the building's roof?"                            />
                <InputField    field="floorConstruction"           type="String"       inline={ true }           label="What is the construction material of the building floors (not ground floor)?"                               />
                <InputField    field="epsPercent"                  type="Percent"      inline={ true }           label="What percentage of the internal walls contain EPS/Sandwich Panels?"         help="EPS is an outer covering of sheet metal and core filled with an insulating material such as expanded polystyrene, polyurethane foam or other forms of filling."/>
                <InputField    field="aluminiumCompositePanels"    type="Boolean"                                label="Does the building have Aluminium Composite Panels (ACP)?"                   help="Aluminium panels either side of an EPS (expanded polystryrene), Polyurethane, Polyethylene, Rockwool and XFLAM or Styrofoam core."/>			

                <StepBlock>
                    <Alert show={ fields.aluminiumCompositePanels === true }>
                        <p>To assist with our assessment of the increased risk due to ACP, we ask that the Owners Corporation (or their Strata Manager or Broker) provide the following:-
                            <ul>
                                <li>A copy of the plans to check if there are any areas identified that have ACP</li>
                                <li>Provide the full product name including -
                                    <ul>
                                        <li>Amount of product used in both % of facade and also value - preferably with a diagram showing the extent of the ACP</li>
                                        <li>How the ACP has been affixed to the building</li>
                                    </ul>
                                </li>
                                <li>For multiple products, you will need to provide the information above for all products.</li>
                            </ul>
                        </p>
                    </Alert>
                </StepBlock>

                <Button.Container>
                    <Button.Back route="/step-5" /> <Button.Save onClick={ this.save.bind(this) }/> <Button.Continue onClick={ this.onContinue.bind(this)} />
                </Button.Container>
            </div>
        )
    }


    save(){
       this.props.actions.submission.save("/step-6", [
            require("./step-1").formConfig,
            require("./step-2").formConfig,
            require("./step-3").formConfig,
            require("./step-4").formConfig,
            require("./step-5").formConfig,
            require("./step-6").formConfig,
        ])
    }


    onContinue(){
        this.props.actions.validation.validate( this.proceed.bind(this) )
    }


    proceed(){
        this.props.actions.navigation.changeRoute("/step-7")
    }


}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/isaver-quote/routes/step-6.tsx